import React from 'react'

import { LntEmpty } from '@app/components/base'
import { NotificationItem } from '@app/components/NotificationMenu/components'

import { isEmptyArray, isNullable } from '@app/utils'
import { presentedEmptyImage } from '@app/components/base/Empty/constants'

import styles from './styles.module.scss'

import type { NotificationListProps } from './types'

export const NotificationList: React.FC<NotificationListProps> = ({ notificationList }) => {
  if (isNullable(notificationList) || isEmptyArray(notificationList)) {
    return (
      <div className={ styles.notificationList__placeholder }>
        <LntEmpty
          image={ presentedEmptyImage.SIMPLE }
          description='Нет оповещений'
        />
      </div>
    )
  }

  return (
    <div className={ styles.notificationList }>
      { notificationList.map(item => (
        <NotificationItem
          key={ item.id }
          notificationData={ item }
        />
      )) }
    </div>
  )
}
